import axios from '@/axios';

/**
 * A fitting session.
 */
export default class FittingSession
{
    /** @type {?string} The UUIDv4 primary key. */
    id = null;

    /** @type {?string} The (hashed) ID of the entity owning the session. */
    entity_id = null;

    /** @type {?number} The ID of the user who first created the session. */
    user_id = null;

    constructor({
        id        = null,
        entity_id = null,
        user_id   = null,
    } = {})
    {
        this.id        = id;
        this.entity_id = entity_id;
        this.user_id   = user_id;
    }

    /**
     * Request a new fitting session ID from the back-end.
     *
     * @async
     * @param {string} eid        The hashed ID of the entity.
     * @returns {Promise<string>} The UUIDv4 primary key of the newly-created
     *                            fitting session.
     */
    static async create(eid)
    {
        try
        {
            const { data } = await axios.post(`/api/fitting-session/${eid}`);
            return data;
        }
        catch(error)
        {
            const err = error?.message ?? error;
            throw new Error(`Could not get fitting session ID: ${err}`);
        }
    }
}
